import { Button, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  saveButton: {
    borderRadius: "24px",
  },
}));

interface Props {
  translations: { save: string };
  disabled: boolean;
  submit: () => void;
  loading: boolean;
}

export const AccountActionButtons: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { translations, submit, disabled, loading } = props;

  return (
    <Grid container direction="row">
      <Grid item xs={6}></Grid>
      <Grid item xs={6}>
        <Button
          className={classes.saveButton}
          variant="contained"
          color="primary"
          disabled={disabled}
          onClick={() => submit()}
          fullWidth
        >
          {loading ? <CircularProgress /> : translations.save}
        </Button>
      </Grid>
    </Grid>
  );
};
